import { render, staticRenderFns } from "./GoalProgress.vue?vue&type=template&id=21e531b5&scoped=true&"
import script from "./GoalProgress.vue?vue&type=script&lang=js&"
export * from "./GoalProgress.vue?vue&type=script&lang=js&"
import style0 from "./GoalProgress.vue?vue&type=style&index=0&id=21e531b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e531b5",
  null
  
)

export default component.exports